import { getListAttrs, setListAttrs } from "../todoNode";
export const getTodoListNode = options => {
  return {
    attrs: {},
    content: 'todo_list_item+',
    listRole: 'list',
    isolating: true,
    group: 'block',
    parseDOM: [{
      tag: 'ul[data-todo-list]',
      getAttrs: dom => getListAttrs(dom)
    }],
    toDOM(node) {
      let listAttrs = {};
      listAttrs.class = 'todo-list';
      listAttrs['data-todo-list'] = true;
      return ['ul', listAttrs, 0];
    }
  };
};